(() => {
    function storeToUrl(website) {
      const current_shop = window.Shopify.shop;
      const shop_country = window.Shopify.country;
      let url;

      // USCA-5431
     if (shop_country == 'CA')      
     {
      switch (current_shop) {
        case "pws-dev-us.myshopify.com":
          url = `https://caoci-qa.tupperware.ca/${website}/events`;
          break;
        case "pws-dev-ca.myshopify.com":
          url = `https://caoci-qa.tupperware.ca/${website}/events`;
          break;
        default:
           url = `https://my.tupperware.ca/${website}/events`;
      }
    }
    else
    {
      switch (current_shop) {
        case "pws-dev-us.myshopify.com":
          url = `https://myoci-qa.tupperware.com/${website}/events`;
          break;
        default:
          url = `https://my.tupperware.com/${website}/events`;
      }
    }
      

      /*
      switch (current_shop) {
        case "pws-dev-us.myshopify.com":
          url = `https://myoci-qa.tupperware.com/${website}/events`;
          break;
        case "tupperware-usa.myshopify.com":
          url = `https://my.tupperware.com/${website}/events`;
          break;
        case "tupperware-ca.myshopify.com":
          url = `https://my.tupperware.ca/${website}/events`;
          break;
        case "pws-dev-ca.myshopify.com":
          url = `https://caoci-qa.tupperware.ca/${website}/events`;
          break;
        default:
          url = `https://my.tupperware.com/${website}/events`;
      }
          */
      return url;
    }
    const pwsHelpersKey = "__pwsHelpers";
  
    if (window[pwsHelpersKey]) {
      return;
    }
  
    let BASE_URL = "https://soa.tupperware.com/twgb/shopify/jk/get";
    let COUNTRY_CODE = "US";
    
    // USCA-5431
    COUNTRY_CODE = window.Shopify.country;
  
    if (window.location.host.includes("pws-dev-us.myshopify.com")) {
      BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
    }
  
    if (window.location.host.includes("tupperware.ca")) {
      COUNTRY_CODE = "CA";
    }
  
    if (window.location.host.includes("pws-dev-ca.myshopify.com")) {
      COUNTRY_CODE = "CA";
      BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
    }
  
    const config = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
  
    const getPartyDetails = async (baseUrl, countryCode, id) => {
      const url = `${baseUrl}/partydetails/v1rs?Country=${countryCode}&PartyNumber=${id}`;
      const response = await fetch(url, config);
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const partyDetails = await response.json();
  
      // Check if the ExpireDate has passed
      const expireDate = new Date(partyDetails.ExpireDate);
      const currentDate = new Date();
  
      if (expireDate < currentDate) {
        showModal();
      }
  
      return partyDetails;
    };
  
    const getAccountDetails = async (baseUrl, countryCode, id) => {
      const url = `${baseUrl}/accountdetails/v1rs?Country=${countryCode}&AccountId=${id}`;
      const response = await fetch(url, config);
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const accountDetails = await response.json();
      return accountDetails;
    };
  
    const setLocalStorage = (key, value) => {
      localStorage.setItem(key, value);
    };
  
    const setSessionStorage = (key, value) => {
      sessionStorage.setItem(key, value);
    };
  
    const getLocalStorage = (key) => localStorage.getItem(key);
  
    const removeLocalStorage = (key) => {
      localStorage.removeItem(key);
    };
  
    const renderSingleBanner = (consultantName, website) => {
      if (consultantName.length > 12 && window.matchMedia("(max-width: 728px)").matches) {
        // If so, truncate the name and add "..."
        consultantName = consultantName.substring(0, 12) + "...";
      }
      let backUrl = website ? storeToUrl(website) : "#";
      const pointerEvents = website ? "" : 'style="pointer-events: none;"';
  
      const singleBannerHTML = `
      <div class="pws_banner-top bg-banner-pws">
      <a ${pointerEvents} href="${backUrl}" title="${consultantName}" class="pws_banner-top__text"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="#292929">
      <g clip-path="url(#clip0_2_56)">
        <path d="M10 11.25C13.1055 11.25 15.625 8.73047 15.625 5.625C15.625 2.51953 13.1055 0 10 0C6.89453 0 4.375 2.51953 4.375 5.625C4.375 8.73047 6.89453 11.25 10 11.25ZM15 12.5H12.8477C11.9805 12.8984 11.0156 13.125 10 13.125C8.98438 13.125 8.02344 12.8984 7.15234 12.5H5C2.23828 12.5 0 14.7383 0 17.5V18.125C0 19.1602 0.839844 20 1.875 20H18.125C19.1602 20 20 19.1602 20 18.125V17.5C20 14.7383 17.7617 12.5 15 12.5Z" fill="white"/>
      </g>
      <defs> 
        <clipPath id="clip0_2_56">
          <rect width="20" height="20" fill="#292929"/>
        </clipPath>
      </defs>
    </svg> <p class="pws_banner-pre">Shopping with:</p> <p class="pws_banner-consultant"> ${consultantName} </p></a>
      </div>`;
  
      const container = document.querySelector("[data-pws-banner-container]");
      container.innerHTML = singleBannerHTML;
    };
  
    const renderMultiBanner = (partyName, time, zone, consultantName, url, website) => {
      if (consultantName.length > 12 && window.innerWidth < 728) {
        consultantName = consultantName.substring(0, 12) + "...";
      }
      let backUrl = storeToUrl(website);
      const multiBannerHTML = `
      <div class="pws_banner-top flex bg-banner-pws">
        <div class="pws_banner-top__left">
          <a href="${backUrl}" title="${consultantName}" class="pws_banner-top__text-party">${partyName}</a>
          <a href="${backUrl}" title="${consultantName}" class="pws_banner-top__text-party">Shopping with: ${consultantName}</a>
        </div>
        <div class="pws_banner-top__right">
          <a href="${url}" class="pws_banner-top__change">Change Party</a>
          <a href="#" class="pws_banner-top__leave ">Leave Party</a>
        </div>
      </div>`;
  
      const container = document.querySelector("[data-pws-banner-container]");
      container.innerHTML = multiBannerHTML;
  
      const leaveParty = container.querySelector(".pws_banner-top__leave");
  
      leaveParty.addEventListener("click", (e) => {
        e.preventDefault();
        removeLocalStorage("party");
        removeLocalStorage("__attribution-party-id");
        window.history.pushState({}, null, window.location.href.split("?")[0]);
        window.location.reload();
      });
    };
  
    const renderInactiveParty = () => {
      let unattachedId = localStorage.getItem("twcid");
      let unattachedParty = localStorage.getItem("twpid");
      localStorage.removeItem('consultant');
      localStorage.removeItem('party');
      // Base banner content, using unattachedId
      if (unattachedId && unattachedParty === null) { 
        
        var singleBannerHTML = `
        <div class="pws_banner-top bg-banner-pws">
        <a href="#" title="${unattachedId}" class="pws_banner-top__text"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_2_56)">
          <path d="M10 11.25C13.1055 11.25 15.625 8.73047 15.625 5.625C15.625 2.51953 13.1055 0 10 0C6.89453 0 4.375 2.51953 4.375 5.625C4.375 8.73047 6.89453 11.25 10 11.25ZM15 12.5H12.8477C11.9805 12.8984 11.0156 13.125 10 13.125C8.98438 13.125 8.02344 12.8984 7.15234 12.5H5C2.23828 12.5 0 14.7383 0 17.5V18.125C0 19.1602 0.839844 20 1.875 20H18.125C19.1602 20 20 19.1602 20 18.125V17.5C20 14.7383 17.7617 12.5 15 12.5Z" fill="white"/>
        </g>
        <defs> 
          <clipPath id="clip0_2_56">
            <rect width="20" height="20" fill="#292929"/>
          </clipPath>
        </defs>
      </svg> <p class="pws_banner-pre">Shopping with:</p> <p class="pws_banner-consultant"> ${unattachedId}</p></a>
      </div>`;
      }
      // Modify the banner content if unattachedParty is available
      else if (unattachedId && unattachedParty) {
          var singleBannerHTML = `
          <div class="pws_banner-top flex bg-banner-pws">
            <div class="pws_banner-top__left">            
              <a  class="pws_banner-top__text-party"><strong>Shopping with: ${unattachedId}</strong></a>
              <a class="pws_banner-top__text-party">For Party: ${unattachedParty}</a>
            </div>
          </div>`;
      }
  
      const container = document.querySelector("[data-pws-banner-container]");
      container.innerHTML = singleBannerHTML;
    };
  
    const renderInactiveBanner = () => {
      let unattachedId = localStorage.getItem("twcid");
      let unattachedParty = localStorage.getItem("twpid");
      localStorage.removeItem('consultant');
      localStorage.removeItem('party');
      // Base banner content, using unattachedId
      if (unattachedId && unattachedParty === null) { 
        
        var singleBannerHTML = `
        <div class="pws_banner-top bg-banner-pws">
        <a href="#" title="${unattachedId}" class="pws_banner-top__text"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_2_56)">
          <path d="M10 11.25C13.1055 11.25 15.625 8.73047 15.625 5.625C15.625 2.51953 13.1055 0 10 0C6.89453 0 4.375 2.51953 4.375 5.625C4.375 8.73047 6.89453 11.25 10 11.25ZM15 12.5H12.8477C11.9805 12.8984 11.0156 13.125 10 13.125C8.98438 13.125 8.02344 12.8984 7.15234 12.5H5C2.23828 12.5 0 14.7383 0 17.5V18.125C0 19.1602 0.839844 20 1.875 20H18.125C19.1602 20 20 19.1602 20 18.125V17.5C20 14.7383 17.7617 12.5 15 12.5Z" fill="white"/>
        </g>
        <defs> 
          <clipPath id="clip0_2_56">
            <rect width="20" height="20" fill="#292929"/>
          </clipPath>
        </defs>
      </svg> <p class="pws_banner-pre">Shopping with:</p> <p class="pws_banner-consultant"> ${unattachedId}</p></a>
      </div>`;}
  
      // Modify the banner content if unattachedParty is available
      else if (unattachedId && unattachedParty) {
          var singleBannerHTML = `
          <div class="pws_banner-top flex bg-banner-pws">
            <div class="pws_banner-top__left">            
              <a  class="pws_banner-top__text-party"><strong>Shopping with: ${unattachedId}</strong></a>
              <a class="pws_banner-top__text-party">For Party: ${unattachedParty}</a>
            </div>
          </div>`;
      }
  
      const container = document.querySelector("[data-pws-banner-container]");
      container.innerHTML = singleBannerHTML;
    };
  
    const singleBanner = document.querySelector("[data-pws-banner-container]");
    const defaultBannerDesktop = document.querySelector(".unattached-banner.desktop-only");
    const defaultBannerMobile = document.querySelector(".unattached-banner.mobile-only");
  
    function getDefaultBanner() {
      return window.matchMedia("(max-width: 990px)").matches ? defaultBannerMobile : defaultBannerDesktop;
    }
  
    function showDefaultBanner() {
      const defaultBanner = getDefaultBanner();
      if (defaultBanner) {
        defaultBanner.style.display = "flex";
      }
    }
  
    function hideDefaultBanner() {
      const defaultBanner = getDefaultBanner();
      if (defaultBanner) {
        defaultBanner.style.display = "none";
      }
    }
  
    window.onload = () => {
        // Select single and default banners
        const singleBanner = document.querySelector("[data-pws-banner-container]");
        const defaultBannerDesktop = document.querySelector(".unattached-banner");
        const hasID = localStorage.getItem("twcid");
        const hasConsultant = localStorage.getItem("consultant");
        const hasParameter = window.location.search.includes("twcId");
      
        // Function to determine the default banner based on screen size
        function getDefaultBanner() {
          return window.matchMedia("(max-width: 990px)").matches ? defaultBannerMobile : defaultBannerDesktop;
        }
      
        // Function to show the default banner
        function showDefaultBanner() {
          const defaultBanner = getDefaultBanner();
          if ( !hasParameter || !hasConsultant || !hasID) {
            defaultBannerDesktop.style.display = "flex";
          }
        }
      
        // Function to hide the default banner
        function hideDefaultBanner() {
          const defaultBanner = getDefaultBanner();
          if ( hasParameter || hasConsultant || hasID) { 
            defaultBannerDesktop.style.display = "none";
          }
        }
      
        // Check the state of the single banner and take action
        if (singleBanner && window.getComputedStyle(singleBanner).display !== "none") {
          // Single banner is visible, hide the default banner
          hideDefaultBanner();
        } else {
          // Single banner is not visible, show the default banner
          showDefaultBanner();
        }
      };
      
    
    const showModal = () => {
      const modalHTML = `
        <div class="modal" id="expireModal">
          <div class="modal-content">
            <span class="close-button" id="closeModal">&times;</span>
            <p>The party has expired.</p>
          </div>
        </div>
      `;
  
      document.body.insertAdjacentHTML('beforeend', modalHTML);
  
      const modal = document.getElementById('expireModal');
      const closeButton = document.getElementById('closeModal');
  
      modal.style.display = 'block';
  
      closeButton.addEventListener('click', () => {
        modal.style.display = 'none';
      });
  
      window.addEventListener('click', (event) => {
        if (event.target == modal) {
          modal.style.display = 'none';
        }
      });
    };
  
    const pwsHelpers = {
      setLocalStorage,
      getLocalStorage,
      setSessionStorage,
      removeLocalStorage,
      getAccountDetails,
      getPartyDetails,
      BASE_URL,
      COUNTRY_CODE,
      renderSingleBanner,
      renderMultiBanner,
      renderInactiveBanner,
      renderInactiveParty,
      ready: true,
    };
  
    window[pwsHelpersKey] = pwsHelpers;
  
    const readyEvent = new CustomEvent(`${pwsHelpersKey}_ready`, {
      detail: pwsHelpers,
      bubbles: true,
      cancelable: true,
      composed: true,
    });
  
    document.dispatchEvent(readyEvent);
  })();
  